// src/SchoolApp.jsx

import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Homepage from './pages/Homepage';
import AdminDashboard from './pages/admin/AdminDashboard';
import LoginPage from './pages/LoginPage';
import StudentDashboard from './pages/student/stuDashboard';
import PrivateRoute from './pages/PrivateRoute';
import FacDashboard from './pages/Faculty/FacDashboard';
import StaffDashboard from './pages/Staff/staffDash';
import RegisterSchool from './pages/RegisterSchool';
import Dashboard from './pages/Adminstrator/Dashboard';
import ContactForm from './pages/Contact/contactForm';
import Navbar from './components/Navbar';
import SchoolLandingPage from './SchoolPages/SchoolLandingPage';
import { verifySession } from './features/auth/authSlice';
import SchoolHeader from './SchoolPages/SchoolHeader';

const hideNavbarRoutes = [
    '/Adminstrator/dashboard',
    '/Admin/dashboard',
    '/StudentDashboard',
    '/FacultyDashboard',
    '/StaffDashboard',
];

const SchoolApp = () => {

    const location = useLocation();
    const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(verifySession());
    }, [dispatch]);




    return (
        <div className="bg-white min-h-screen">
            {/* {!shouldHideNavbar && <SchoolHeader />} */}
            <Routes>
                <Route path="/" element={<SchoolLandingPage />} />
                <Route path="/loginPage" element={<LoginPage />} />
                <Route path="/Admin/dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
                <Route path="/Adminstrator/dashboard" element={<Dashboard />} />
                <Route path="/StudentDashboard" element={<PrivateRoute><StudentDashboard /></PrivateRoute>} />
                <Route path="/FacultyDashboard" element={<PrivateRoute><FacDashboard /></PrivateRoute>} />
                <Route path="/StaffDashboard" element={<PrivateRoute><StaffDashboard /></PrivateRoute>} />
            </Routes>
        </div>
    );
};

export default SchoolApp;
